<mat-toolbar>
  <h1 class="filename">{{file.fileName}}</h1>
</mat-toolbar>
<div class="file-info">
  <app-files-auth></app-files-auth>
  <div class="file-preview video-preview" *ngIf="previewIsVideo && showPreview">
    <video [src]="previewURL" controls></video>
  </div>
  <div class="file-preview" *ngIf="file.contentType.includes('image') && showPreview" [style]="previewStyle">
  </div>
  <div class="file-preview" *ngIf="file.contentType === 'application/pdf' && showPreview && !optixPreview">
    <iframe [src]="cleanPreviewURL"  width="100%" height="500px">
    </iframe>
  </div>
  <div class="file-preview" *ngIf="file.contentType === 'application/pdf' && showPreview && optixPreview">
    <div class="loading-shade" *ngIf="loadingPreview">
      <mat-spinner></mat-spinner>
    </div>
    <iframe #optixPreview [src]="cleanPreviewURL"  [width]="getWidth()" [height]="getHeight()">
    </iframe>
  </div>
  <div class="list-wrapper" *ngIf="!superSimpleView">
    <ng-container *ngIf="!simpleView">
      <mat-list>
        <mat-list-item><span mat-line>Uploaded By</span> <span mat-line>{{file.uploadedBy}}</span></mat-list-item>
        <mat-list-item><span mat-line>Uploaded On</span> <span mat-line>{{file.uploadedOn | date: 'mediumDate'}}</span>
        </mat-list-item>
        <mat-list-item><span mat-line>Content Type</span> <span mat-line>{{file.contentType}}</span></mat-list-item>
        <mat-list-item><span mat-line>File Name</span> <span mat-line>{{file.fileName}}</span></mat-list-item>
        <mat-list-item><span mat-line>Original File Name</span> <span mat-line>{{file.originalFileName}}</span></mat-list-item>
        <mat-list-item><span mat-line>URL</span> <pre mat-line>{{previewURL}}</pre></mat-list-item>
      </mat-list>
    </ng-container>
    <ng-container *ngIf="simpleView">
      <mat-list>
        <mat-list-item><span mat-line>File Name</span> <span mat-line>{{file.fileName}}</span></mat-list-item>
        <mat-list-item><span mat-line>Content Type</span> <span mat-line>{{file.contentType}}</span></mat-list-item>
        <mat-list-item><span mat-line>URL</span> <pre mat-line>{{previewURL}}</pre></mat-list-item>
      </mat-list>
    </ng-container>
  </div>
  <div class="actions">
    <a mat-flat-button target="_blank" [href]="previewURL" download>Download</a>
    <button mat-flat-button color="warn" (click)="deleteFile()" *ngIf="allowDelete">Delete</button>
  </div>
</div>
